var _defs, _use, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrizzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 359 231"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e2e8f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: "M295.5 223.5a56 56 0 000-112l-2.5.1a83.9 83.9 0 00-153-64.2 56 56 0 00-84.6 48.1 56.6 56.6 0 00.8 9 60 60 0 0011.2 119"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 359,
    height: 231,
    transform: "translate(76.5 140.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0a5ad4",
    d: "M200 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x1",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; x1.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y1",
    attributeName: "opacity",
    begin: "0s; y1.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a5ad4",
    d: "M256 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x2",
    additive: "sum",
    attributeName: "transform",
    begin: "1.34s; x2.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y2",
    attributeName: "opacity",
    begin: "1.34s; y2.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a5ad4",
    d: "M312 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x3",
    additive: "sum",
    attributeName: "transform",
    begin: ".67s; x3.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y3",
    attributeName: "opacity",
    begin: ".67s; y3.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrizzle);
export default __webpack_public_path__ + "static/media/drizzle.caab99949a175b000ba854db4a3a0cd9.svg";
export { ForwardRef as ReactComponent };